import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';
import { LogisticFeatureDefinition } from '@digiwall/goliath-documents/config';
import { StockFeatureDefinition } from '@digiwall/goliath-products/config';
import { InventoryCountDocListComponent } from '../documents/inventory-count-docs/inventory-count-doc-list/inventory-count-doc-list.component';
import { InventoryCountDocDetailComponent } from '../documents/inventory-count-docs/inventory-count-doc-detail/inventory-count-doc-detail.component';

const routes: Routes = [
  {
    path: 'logistics',
    // Inventory counting requires BOTH the logistics and stock features.
    canMatch: [LogisticFeatureDefinition, StockFeatureDefinition],
    data: {
      breadcrumb: { skip: true } as BreadcrumbDefinition,
    },
    children: [
      {
        path: 'inventory-count-doc',
        data: {
          breadcrumb: {} as BreadcrumbDefinition,
        },
        children: [
          {
            path: '',
        component: InventoryCountDocListComponent,
            data: {
              breadcrumb: { label: 'Doc::Menu:InventoryCounts' } as BreadcrumbDefinition,
            },
      },
      {
            path: ':id',
        component: InventoryCountDocDetailComponent,
            data: {
              breadcrumb: { alias: 'entityName' } as BreadcrumbDefinition,
            },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoliathDocumentsInventoryCountDocRoutingModule {}
